import {
  AUTH_JWT_TOKEN,
  AUTH_JWT_TOKEN_EXPIRATION,
  AUTH_REFRESH_TOKEN,
  AUTH_REFRESH_TOKEN_EXPIRATION,
  buildOptionalParams,
  buildPath,
  buildTemplatePath,
  Card,
  PageRoute,
  Stack,
  Typography,
  useParams,
  useTheme,
} from "@compass/core";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AuthPageWrapper } from "../components/AuthPageWrapper";
import { setAppAuthStatus } from "redux/reducers/appSlice";
import { tenantListPageRoute } from "pages/authV2/TenantListPage";

const routeName = "auth-callback";

class OptionalParams {
  redirectTo?: string = "";
  resultType: string | undefined = "";
  jwtToken: string | undefined = "";
  jwtTokenExpiration: string | undefined = "";
  refreshToken: string | undefined = "";
  refreshTokenExpiration: string | undefined = "";
  multipleGrants: string | undefined = "";
}

export const AuthCallbackPageRoute: PageRoute<undefined, OptionalParams> = {
  handle: "Login",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
  getOptionalParams: (params: OptionalParams) => buildOptionalParams(params),
};

export const AuthCallbackPage = () => {
  const { optionalParams } = useParams(routeName, undefined, OptionalParams);
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (optionalParams.resultType === "Authenticated") {
      localStorage.setItem(AUTH_JWT_TOKEN, optionalParams.jwtToken!);
      localStorage.setItem(AUTH_JWT_TOKEN_EXPIRATION, optionalParams.jwtTokenExpiration?.toString()!);
      localStorage.setItem(AUTH_REFRESH_TOKEN, optionalParams.refreshToken!);
      localStorage.setItem(AUTH_REFRESH_TOKEN_EXPIRATION, optionalParams.refreshTokenExpiration?.toString()!);

      dispatch(setAppAuthStatus("AUTHENTICATED"));

      // If only one tenant, just take them to home page, otherwise they select tenants
      if (optionalParams.multipleGrants?.toLocaleLowerCase() == "false") {
        navigate("/");
        window.location.reload();
      }
      else {
        navigate(optionalParams.redirectTo || `/${tenantListPageRoute.getPath()}`);
      }
    }
  }, []);


  return (
    <AuthPageWrapper>
      <Card sx={{ maxWidth: "500px", width: "100%" }}>
        <Stack px={3} py={7} spacing="lg">
          <Stack spacing="sm" alignItems="center">
            <Typography variant="subtitle2">
              Logging in...
            </Typography>
          </Stack>
        </Stack>
      </Card>
    </AuthPageWrapper>
  );
};